<template>
	<div id="setsumei" class="itemBuyContainer">
		<template v-if="ptInitData.productInfo.HANBAI_FLG == 1">
			<template v-if="ptInitData.productInfo.YOYAKU_ITEM_FLG != 1">
				<template
					v-if="ptInitData.productInfo.ZAIKO_DISP_PLACE_KBN == 0 || ptInitData.productInfo.ZAIKO_DISP_PLACE_KBN == 2 && ptInitData.productInfo.ZAIKO_DISP_WAY_KBN != 0">
					<template
						v-if="ptInitData.productInfo.ZAIKO_DISP_WAY_KBN == '2' || ptInitData.productInfo.ZAIKO_DISP_WAY_KBN == '3'">
						<dl class="doukon sort-item"
							v-if="ptInitData.productInfo.CART_ADD_KBN == 3 && ptInitData.hanbaiQtyAvaiable !== -999999999">
							<!--販売可能数-->
							<dt>{{ $t('pt125.labels.hanbaiQty') }}</dt>
							<dd>
								<span style="font-size: 12px;">{{ formatPrice(ptInitData.hanbaiQtyAvaiable) }}</span>
							</dd>
						</dl>
						<dl class="zaikoQty sort-item" v-else>
							<dt>{{ $t('pt125.labels.numberOfStock') }}</dt>
							<dd>
								<span style="font-size: 12px;">{{ formatPrice(ptInitData.productInfo.ZAIKO_QTY)
									}}</span>
							</dd>
						</dl>
					</template>
					<template
						v-if="ptInitData.productInfo.ZAIKO_DISP_WAY_KBN == '1' || ptInitData.productInfo.ZAIKO_DISP_WAY_KBN == '3'">
						<template
							v-if="ptInitData.productInfo.ZAIKO_QTY > ptInitData.productInfo.ZAIKO_CNT && !doChkCartAddTxt && ptInitData.productInfo.NO_LIMIT_FLG != 1">
							<dl class="zaikoMsg1 sort-item">
								<dt>{{ $t('pt125.labels.stock') }}</dt>
								<dd>
									{{ ptInitData.productInfo.ZAIKO_MSG1 }}
									<span><a href="#" @click.prevent="showModal"
											v-if="ptInitData.hanbaiQtySettingDisplayFlg === 1">{{
												$t('common.labels.productZaikoConf') }}</a></span>
								</dd>
							</dl>
						</template>
						<template
							v-else-if="ptInitData.productInfo.ZAIKO_QTY <= ptInitData.productInfo.ZAIKO_CNT && ptInitData.productInfo.ZAIKO_QTY >= 1 && !doChkCartAddTxt && ptInitData.productInfo.NO_LIMIT_FLG != 1">
							<dl class="zaikoMsg2 sort-item">
								<dt>{{ $t('pt125.labels.stock') }}</dt>
								<dd>
									{{ ptInitData.productInfo.ZAIKO_MSG2 }}
									<span><a href="#" @click.prevent="showModal"
											v-if="ptInitData.hanbaiQtySettingDisplayFlg === 1">{{
												$t('common.labels.productZaikoConf') }}</a></span>
								</dd>
							</dl>
						</template>
						<template
							v-else-if="ptInitData.productInfo.ZAIKO_QTY <= 0 || doChkCartAddTxt || ptInitData.productInfo.NO_LIMIT_FLG == 1">
							<dl class="zaikoMsg3 sort-item">
								<dt>{{ $t('pt125.labels.stock') }}</dt>
								<dd>
									{{ ptInitData.productInfo.ZAIKO_MSG3 }}
								</dd>
							</dl>
						</template>
					</template>
				</template>
			</template>
		</template>
		<template v-if="ptInitData.productInfo.HANBAI_FLG == 1">
			<dl class="doukon sort-item">
				<dt>{{ $t('pt125.labels.doukon') }}</dt>
				<dd v-if="ptInitData.productInfo.BESSOU_GRP_KBN == '0'">
					{{ $t('pt125.labels.doukonYes') }}
				</dd>
				<dd v-else-if="ptInitData.productInfo.BESSOU_GRP_KBN == '999'">
					{{ $t('pt125.labels.doukonNot') }}
				</dd>
				<dd v-else>
					{{ $t('pt125.labels.doukonCondition') }}
				</dd>
			</dl>
		</template>
	</div>
</template>
<script>
import common from "assets/js/common";
export default {
	name: 'itemBuyContainer',
	props: {
		ptInitData: {
			type: Object,
			default: null
		},
		doChkCartAddTxt: {
			type: Boolean
		},
	},
	components: {
	},
	methods: {
		/**
	* format number value to currency value
	* @param {number} value, number to format
	*/
		formatPrice: function (value) {
			return common.formatPrice(value);
		},
		showModal: function () {
			this.$emit('showModal');
		}
	},
}
</script>